import { isMobileDesign } from 'Utils/mobile';
import React from 'react';
import { Toaster } from 'react-hot-toast';

const APP_MENU_PADDING = 96;
const mobileMenuPad = isMobileDesign() ? APP_MENU_PADDING : 0;

const AppToast = () => (
  <Toaster
    position="bottom-center"
    containerStyle={{
      bottom: mobileMenuPad + 50,
    }}
    toastOptions={{
      duration: 3500,
    }}
  />
);

export default AppToast;
